import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import moment from 'moment';
import { useFormik, Form, FormikProvider } from 'formik';
import { makeStyles } from '@material-ui/styles';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import Controls from '../controls/Controls';
import {
  baseUrl,
  services,
  memberTypes,
  departments,
  tierSchemes,
  limitTypes,
  gender
} from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';
import { useConstantsContext } from '../../context/constants_context';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  color: {
    backgroundColor: '#f5f5f5'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function LimitsMgmtSub() {
  const classes = useStyles();
  const { setLimitSetUp, limitSetup } = useSettingContext();
  const [openPopup, setOpenPopup] = useState(false);
  const [providerCodes, setProviderCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });

  useEffect(() => {
    // getProviderDisciplines();
    // if (providerId > 0) {
    //   populateProvider(providerId);
    // }
    console.log('limtsetup info', limitSetup);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limitSetup]);

  const LimitsSchema = Yup.object().shape({
    schemE_ID: Yup.number().required('Scheme Type is required'),
    servtypE_ID: Yup.number().required('Service Type is required'),
    membertypE_ID: Yup.number().required('Member Type is required'),
    depT_ID: Yup.number().required('Department is required')
  });

  const formik = useFormik({
    initialValues: limitSetup,
    enableReinitialize: true,
    validationSchema: LimitsSchema,
    onSubmit: (values) => {
      console.log('setting 2', values);
      values.benefitGender = values.benefitGender.toString();
      values.user_id = sessionStorage.getItem('oldRefId');
      saveLimit(values);
    }
  });

  if (limitSetup.startdate)
    limitSetup.startdate = moment(limitSetup.startdate).format('yyyy-MM-DD');

  const saveLimit = (prod) => {
    const jsonClient = [];
    jsonClient.push(prod);
    console.log('provider stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/setting/saveSchemeServiceBenefit`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((result) => result.json())
      .then(
        (result) => {
          setLimitSetUp(result);
          notifyPopup(`Limits Setting Saved Successfully!`, 'success');
        },
        (error) => {
          notifyPopup(`Error in Saving Limit!: ${error}`, 'error');
        }
      );
  };

  const closePopup = () => {
    setOpenPopup(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Card>
      <CardContent>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate>
            <Typography variant="subtitle1" gutterBottom>
              Provider Setup...
            </Typography>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              <Grid item xs={12} sm={2}>
                <Controls.Input name="recorD_ID" label="Record #" disabled />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="schemE_IDTxt">Scheme</InputLabel>
                  <Select
                    value={formik.values.schemE_ID}
                    name="schemE_ID"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={(e) => {
                      formik.setFieldValue('schemE_ID', e.target.value);
                    }}
                  >
                    <MenuItem key="" value="">
                      Not Selected
                    </MenuItem>
                    {tierSchemes.map((item) => (
                      <MenuItem key={item.refId} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="service_Type_IdTxt">Service Type</InputLabel>
                  <Select
                    value={formik.values.servtypE_ID}
                    name="servtypE_ID"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={(e) => {
                      formik.setFieldValue('servtypE_ID', e.target.value);
                    }}
                  >
                    <MenuItem key="" value="">
                      Not Selected
                    </MenuItem>
                    {services.map((item) => (
                      <MenuItem key={item.refId} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={5}>
                <FormControl fullWidth>
                  <InputLabel id="membertypE_IDTxt">Service Type</InputLabel>
                  <Select
                    value={formik.values.membertypE_ID}
                    name="membertypE_ID"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={(e) => {
                      formik.setFieldValue('membertypE_ID', e.target.value);
                    }}
                  >
                    <MenuItem key="" value="">
                      Not Selected
                    </MenuItem>
                    {memberTypes.map((item) => (
                      <MenuItem key={item.refId} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={5}>
                <FormControl fullWidth>
                  <InputLabel id="depT_IDTxt">Service Type</InputLabel>
                  <Select
                    value={formik.values.depT_ID}
                    name="depT_ID"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={(e) => {
                      formik.setFieldValue('depT_ID', e.target.value);
                    }}
                  >
                    <MenuItem key="" value="">
                      Not Selected
                    </MenuItem>
                    {departments.map((item) => (
                      <MenuItem key={item.refId} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={5} mb={2}>
                <Controls.CheckBox name="forceAuthorisation" label="Force Authorisation" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="waitingPeriod" label="Waiting Period" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="cover" label="Cover (%)" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="threshHold" label="Threshold Amount" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="atB_Cover" label="ATB Cover (%)" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="atB_CoPayment" label="ATB Cover Amount" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="limit" label="Limit Amount" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="limitDays" label="Limit Days" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="limitTypeLabel">Limit Type</InputLabel>
                  <Select
                    id="limitType_id"
                    value={formik.values.limitType_id}
                    name="limitType_id"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={(e) => {
                      formik.setFieldValue('limitType_id', e.target.value);
                    }}
                  >
                    <MenuItem key="" value="0">
                      Not Selected
                    </MenuItem>
                    {limitTypes.map((item) => (
                      <MenuItem key={item.refId} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.DateTime name="startdate" label="Start Date" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.CheckBox name="tarrif" label="Tarrif" />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.Input name="claimLimit" label="Claim Limit" />
              </Grid>

              <Grid item xs={12} sm={3}>
                <Controls.CheckBox name="ppn" label="PPN" />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.CheckBox name="terminateMember" label="Terminate Member" />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.SelectJson name="benefitGender" label="Gender" options={gender} />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.Input name="ageBased" label="Age Based" />
              </Grid>
            </Grid>

            <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
              <Grid item xs={12} sm={1} marginRight={1}>
                <Controls.Button type="submit" variant="outlined" startIcon={<SaveIcon />}>
                  Save...
                </Controls.Button>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </CardContent>
    </Card>
  );
}
